export const hasUnresolvedPlaceholders = value =>
  /{[^}]+}/.test(String(value || ""));

export const getPlaceholderCandidates = expression =>
  String(expression || "")
    .split("|")
    .map(placeholder => placeholder.trim())
    .filter(Boolean);

export const getPlaceholderKeys = value => {
  const expressions = String(value || "").match(/{([^}]+)}/g) || [];

  return [
    ...new Set(
      expressions.flatMap(expression =>
        getPlaceholderCandidates(expression.slice(1, -1))
      )
    )
  ];
};

export const replaceBracketPlaceholders = (uri, data) => {
  if (uri) {
    const placeholderRegex = /{([^}]+)}/g;
    const replacedUri = uri?.replace(placeholderRegex, (match, expression) => {
      const placeholders = getPlaceholderCandidates(expression);

      for (const placeholder of placeholders) {
        const value = data?.[placeholder];

        if (value !== undefined && value !== null && String(value) !== "") {
          return value;
        }
      }

      return match;
    });
    return replacedUri;
  }
}
